import { EMenuKeys } from 'common/constants/store-config'

export const DEFAULT_HIDDEN_STEPS = [
  `${EMenuKeys.EXPEDITION}-0`,
  `${EMenuKeys.TAX}-0`,
  `${EMenuKeys.ACCOUNTANT}-0`,
  `${EMenuKeys.FINANCIAL}-0`,
]

/* eslint-disable @typescript-eslint/naming-convention */
export enum AppWebStorageKey {
  ReliabilityStatus = 'maas:session.reliability_status',
  SessionOwnerId = 'maas:session.owner_id',
}
